import React from 'react'

const Calendar = ({ size = 16, color = '#525252', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33331 3.33333C2.96512 3.33333 2.66665 3.63181 2.66665 4V13.3333C2.66665 13.7015 2.96512 14 3.33331 14H12.6666C13.0348 14 13.3333 13.7015 13.3333 13.3333V4C13.3333 3.63181 13.0348 3.33333 12.6666 3.33333H3.33331ZM1.33331 4C1.33331 2.89543 2.22874 2 3.33331 2H12.6666C13.7712 2 14.6666 2.89543 14.6666 4V13.3333C14.6666 14.4379 13.7712 15.3333 12.6666 15.3333H3.33331C2.22874 15.3333 1.33331 14.4379 1.33331 13.3333V4Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33331 6.66667C1.33331 6.29848 1.63179 6 1.99998 6H14C14.3682 6 14.6666 6.29848 14.6666 6.66667C14.6666 7.03486 14.3682 7.33333 14 7.33333H1.99998C1.63179 7.33333 1.33331 7.03486 1.33331 6.66667Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6667 0.666656C11.0349 0.666656 11.3333 0.965133 11.3333 1.33332V3.99999C11.3333 4.36818 11.0349 4.66666 10.6667 4.66666C10.2985 4.66666 10 4.36818 10 3.99999V1.33332C10 0.965133 10.2985 0.666656 10.6667 0.666656Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33335 0.666656C5.70154 0.666656 6.00002 0.965133 6.00002 1.33332V3.99999C6.00002 4.36818 5.70154 4.66666 5.33335 4.66666C4.96516 4.66666 4.66669 4.36818 4.66669 3.99999V1.33332C4.66669 0.965133 4.96516 0.666656 5.33335 0.666656Z"
      fill={color}
    />
  </svg>
)

export default Calendar;
